function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGravados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--complete-list--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.55,217.49H224.79a17.64,17.64,0,0,1-17.38-16.42l-2.64-44.48H55.54l2.63,44.48A17.64,17.64,0,0,0,75.55,217.49Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.55,217.49H224.79a17.64,17.64,0,0,1-17.38-16.42l-2.64-44.48H55.54l2.63,44.48A17.64,17.64,0,0,0,75.55,217.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85,127H103a15.3,15.3,0,0,0-15.44,16.41L91,201.08a15.28,15.28,0,0,1-15.44,16.41H224.79a15.28,15.28,0,0,0,15.44-16.41l.37,6.24-3.78-63.87A15.28,15.28,0,0,1,252.26,127Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26,127H103a17.62,17.62,0,0,1,17.38,16.41L133.23,360.1H282.46L269.64,143.45A17.64,17.64,0,0,0,252.26,127Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26,127H103a17.62,17.62,0,0,1,17.38,16.41L133.23,360.1H282.46L269.64,143.45A17.64,17.64,0,0,0,252.26,127Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.66,188.68H143L141.33,161H169ZM146,185.42h21.17L166,164.25H144.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.52,253.79H146.83l-1.64-27.69h27.69Zm-24.63-3.26h21.17l-1.25-21.17H148.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.37,318.9H150.68L149,291.21h27.69Zm-24.62-3.26h21.17l-1.26-21.17H152.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.18,
    y: 160.99,
    width: 63.66,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 173.21,
    width: 56.18,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.62,
    y: 185.42,
    width: 63.66,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.03,
    y: 226.1,
    width: 63.66,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.75,
    y: 238.32,
    width: 37.37,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.48,
    y: 250.53,
    width: 19.29,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.31,
    y: 250.53,
    width: 31.83,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.88,
    y: 291.21,
    width: 63.66,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.61,
    y: 303.43,
    width: 63.66,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.33,
    y: 315.64,
    width: 35.21,
    height: 3.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,182.16a2.7,2.7,0,0,1-1.86-.74L150,175a2.71,2.71,0,1,1,3.73-3.94l4.82,4.55,10.85-11.53a2.71,2.71,0,0,1,3.95,3.72l-12.71,13.51a2.67,2.67,0,0,1-1.9.85Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.49,247.27a2.68,2.68,0,0,1-1.86-.74l-6.8-6.42a2.71,2.71,0,1,1,3.72-3.94l4.83,4.55,10.84-11.53a2.71,2.71,0,0,1,3.95,3.72l-12.71,13.51a2.66,2.66,0,0,1-1.89.85Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34,312.39a2.69,2.69,0,0,1-1.86-.75l-6.8-6.42a2.71,2.71,0,1,1,3.72-3.94l4.83,4.55,10.85-11.53A2.71,2.71,0,0,1,181,298l-12.71,13.51a2.7,2.7,0,0,1-1.9.85Z",
    style: {
      fill: "#07C961"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.04,
    y: 157.97,
    width: 20,
    height: 242.81,
    transform: "translate(-57.19 86.65) rotate(-13.81)",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.74,
    y: 156.31,
    width: 6.09,
    height: 242.81,
    transform: "translate(-56.6 88.21) rotate(-13.81)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.55,
    y: 400.02,
    width: 20,
    height: 15.06,
    rx: 2.25,
    transform: "translate(-86.89 97.88) rotate(-13.81)",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.55,
    y: 400.02,
    width: 20,
    height: 15.06,
    rx: 2.25,
    transform: "translate(-86.89 97.88) rotate(-13.81)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.9,
    y: 393.6,
    width: 23.17,
    height: 11.08,
    rx: 2.08,
    transform: "translate(-84.94 97.14) rotate(-13.81)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.76 159.1 290.34 163.88 292.62 147.63 294.08 137.21 300.21 145.76 309.76 159.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.21 145.76 292.62 147.63 294.08 137.21 300.21 145.76",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.92,143.68c-.1,6-1.26,17.31,1.9,21A43.83,43.83,0,0,0,342.93,177c-4.33-7.08,1.32-10.89,1.32-10.89,6.23-2,5.85-6.69,4.54-11Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.09,170.89c1.65-6.13-3-7,4.75-10,6.06-2.4,17.51-2.74,20.2-.81,1.49,1.08-.56,4.86-.56,4.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.68,169.57c.45.72.77,1.27,1.13,1.9s.66,1.21,1,1.82c.64,1.22,1.24,2.44,1.82,3.68,1.16,2.47,2.17,5,3.1,7.56a82,82,0,0,1,4,16l.26,2.06c.05.29.09.81.12,1.26s0,.86,0,1.26a37.36,37.36,0,0,1-.33,4.41c-.35,2.76-.88,5.37-1.46,8a129.42,129.42,0,0,1-4.47,15.13,2.93,2.93,0,0,1-5.68-1.23v0c.4-5.08.87-10.2,1.24-15.2.18-2.5.32-5,.36-7.36,0-1.17,0-2.33-.11-3.3l-.09-.67-.13-.65-.37-1.74a91,91,0,0,0-4.3-13.74c-.9-2.24-1.87-4.46-2.89-6.65q-.76-1.65-1.59-3.24l-.84-1.58-.79-1.45-.14-.26a5.87,5.87,0,0,1,10.15-5.89Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,234.67l.83-1.38,2.34-3.94,4.29,2.43c.89,4-1.83,7.54-1.83,7.54l-1.21,1a2.15,2.15,0,0,1-2.94-.11l-.93-.86A3.93,3.93,0,0,1,372,234.67Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,232.63l-.69-2.5a2.33,2.33,0,0,0-2.82-1.64l-3,.77-1.85.46a4.63,4.63,0,0,0-3.46,4.37l0,1.49a2.56,2.56,0,0,0,2.37,2.57l1.85.18a12.46,12.46,0,0,0,7.22-3.88A2,2,0,0,0,315,232.63Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.68,165.17c5.25,2.33,10.06,7.88,14,18.15-1.26,4.23-14.27,11.16-14.27,11.16S353.18,160.07,369.68,165.17Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,178.32c.05,3.81-6.26,12.64,1,17.76.63,7.71,1.48,15.3,3.13,27.95h38.83c-3.69-14-.5-23.4,5.42-48a9.47,9.47,0,0,0-8.24-11.77c-1.55-.15-3.19-.28-4.86-.37a123.44,123.44,0,0,0-17.64,0c-1.91.17-3.88.41-5.77.67A13.87,13.87,0,0,0,326.25,178.32Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.11,174.61c.09,2.86,0,5.6,0,8.4s-.18,5.57-.36,8.37a135,135,0,0,1-2,16.92c-.12.71-.31,1.45-.48,2.17s-.32,1.44-.55,2.2l-.32,1.11-.17.56a6.18,6.18,0,0,1-.24.74,11.93,11.93,0,0,1-1.7,3,33,33,0,0,1-3.19,3.57c-1.05,1.05-2.12,2-3.2,3a113.3,113.3,0,0,1-13.52,10,2.94,2.94,0,0,1-3.79-4.41l0,0c3.57-4.07,7.25-8.11,10.68-12.11.84-1,1.66-2,2.44-3a24.35,24.35,0,0,0,2-2.81c.24-.37.39-.82.26-.57s0-.13,0-.24l.09-.44.19-.87c.14-.56.22-1.19.32-1.8s.22-1.22.28-1.86c.68-5.05,1-10.37,1.19-15.69s.31-10.74.34-16v0a5.87,5.87,0,0,1,11.74-.13Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.83,165.45c-4.79,2.38-9.54,7-11.51,17.58,1.25,4.19,18.37,12.26,18.37,12.26S351.22,159.33,334.83,165.45Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.88,139.86c.13.75-.17,1.45-.67,1.54s-1-.43-1.13-1.19.18-1.45.67-1.54S335.76,139.1,335.88,139.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,138.66l-1.91-.16S334.24,139.73,335,138.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.7,140.7a21.18,21.18,0,0,1-1.91,5.36,3.31,3.31,0,0,0,2.8,0Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.9,134.7a.47.47,0,0,1-.31-.12.45.45,0,0,1,0-.64,4.6,4.6,0,0,1,3.91-1.48.44.44,0,0,1,.35.52.47.47,0,0,1-.54.37,3.69,3.69,0,0,0-3.08,1.21A.47.47,0,0,1,333.9,134.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,132.41c1,9.4,1.6,13.36-2.23,19-5.77,8.55-17.37,8-21.1-.83-3.36-8-4.41-22,3.95-27.46A12.42,12.42,0,0,1,360.63,132.41Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53,139.28c-6-1.06-7.45-7.95-5.23-10.95-10.11.45-16.92-10.86-6-17.31s20.56,3.54,19.78,7.31c13.45-1.22,21.33,9.85,14,18.08,9.67,1.57,24.15,12.47,13.52,23.92,14.37,2.11,15.93,47.11-23.19,39.11C315.17,191,351,155.11,351,155.11S340.55,152.17,343.53,139.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,163.26l-.85-.52c3.63-5.9,4.23-11.27,1.78-16-3.15-6-10.79-9.54-16.72-9.88l.06-1c6.2.35,14.23,4,17.55,10.41C386.24,151.27,385.61,157.13,381.84,163.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.47,137.42c3.45-.57,1.82-6.2-.72-7.69s-14.71.93-13.37,4.81S365.84,138.19,370.47,137.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.09,136c3.44-.66,2.06-5.22-.52-6.65s-13.21-.37-11.76,3.46S366.49,136.91,371.09,136Z",
    style: {
      fill: "#07C961"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.05,129.47a10.35,10.35,0,0,1-6.33-2.27c-2.87-2.23-4.45-5.57-4-8.51.27-1.87,1.44-4.44,5.52-6.07l.37.93c-2.88,1.15-4.57,3-4.9,5.28-.36,2.6,1.07,5.57,3.66,7.58a8.8,8.8,0,0,0,8.78,1.46l.38.93A9,9,0,0,1,335.05,129.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,140.38c-.45,2.46-.59,3.51-1.87,4.66a2.71,2.71,0,0,1-4.73-1.77c-.2-2.26.57-5.9,2.86-6.66S346.35,137.93,345.9,140.38Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,148.21l-.81-1.45a.39.39,0,0,1,0-.39l.81-1.44a.4.4,0,0,1,.7,0l.81,1.44a.39.39,0,0,1,0,.39l-.81,1.45A.4.4,0,0,1,340.38,148.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,224s-1.37,50.14-3.2,83.12c-1.94,30.27-4.43,101.06-4.43,101.06l7.65.4s16.92-59.57,16.21-95.56c19.86-50.34,12.72-87.51,12.72-87.51Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.34,405a1,1,0,0,0-1.17,0,21.42,21.42,0,0,1-12.69,4.22c-5.08.22-3.83,3,3.44,3.93,8.55,1.06,10.38,2.82,13.14,3.51s4.95-1.41,4.9-7.21a1,1,0,0,0-.64-.91A33.32,33.32,0,0,1,323.34,405Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,224s14,59.34,22.11,87c8.53,29,15.29,95.18,15.24,97.37h6.62s8.55-53.64-2-97.4c-1-71-13.24-86.92-13.24-86.92Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.73,406a.86.86,0,0,0-1,.26c-1.71,2.22-2.95,4.68-8,6.84-4.18,1.78-1.87,4.22,4.67,3.33,7.69-1.06,7.8.19,10.39.19s3.81-2.58,1.92-8.19a1.06,1.06,0,0,0-.84-.72A30.39,30.39,0,0,1,377.73,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,224s-6.6,43.94-5.67,104a212.09,212.09,0,0,0,61.57-9.5s.3-77.82-17.07-94.47C359.2,221.33,330.63,223.12,330.4,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.17,319.47a.25.25,0,0,1-.25-.24c-1.87-38.35,2.67-92.49,2.71-93a.24.24,0,0,1,.27-.23.25.25,0,0,1,.23.27c-.05.55-4.58,54.65-2.71,93a.24.24,0,0,1-.24.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.3 281.12 362.99 250.98 365.28 258.19 357.3 281.12",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGravados);
export default __webpack_public_path__ + "static/media/gravados.01c230a86c979ac4dad583dd1471faf6.svg";
export { ForwardRef as ReactComponent };